import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";
import { identify, resetAnalytics } from "./analytics";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const t = localStorage.getItem("dap_token");
    // Skip /auth/me while an OAuth callback is being processed
    if (typeof window !== "undefined" && window.location.hash.includes("session_id=")) {
      setReady(true);
      return;
    }
    if (!t) {
      setReady(true);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => {
        setUser(r.data);
        identify(r.data);
      })
      .catch(() => localStorage.removeItem("dap_token"))
      .finally(() => setReady(true));
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("dap_token", r.data.token);
    setUser(r.data.user);
    identify(r.data.user);
    return r.data.user;
  };
  const signup = async (payload) => {
    const r = await api.post("/auth/signup", payload);
    localStorage.setItem("dap_token", r.data.token);
    setUser(r.data.user);
    identify(r.data.user);
    return r.data.user;
  };
  const logout = () => {
    localStorage.removeItem("dap_token");
    setUser(null);
    resetAnalytics();
  };

  return (
    <AuthCtx.Provider value={{ user, ready, login, signup, logout, setUser }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
